export default __webpack_public_path__ + "static/media/ubuntu.b97e3735.png";